class PlantStoreClass {
  constructor() {
      this.state = {
      transmitters: JSON.parse(localStorage.getItem("transmitters") || "{}"),
      valves: JSON.parse(localStorage.getItem("valves") || "{}"),
      interlocks: JSON.parse(localStorage.getItem("interlocks") || "{}"),
      flowOverrides: JSON.parse(localStorage.getItem("flowOverrides") || "{}"),
  };

    this.listeners = new Set();
  }

  get() {
    return this.state;
  }

  set(partial) {

        const next = {
        ...this.state,
        ...partial,
    };

    // nothing changed?
    if (
        JSON.stringify(next) ===
        JSON.stringify(this.state)
    ) {
        return;
    }

    this.state = next;

    if(partial.transmitters){
        localStorage.setItem(
            "transmitters",
            JSON.stringify(next.transmitters)
        );
    }

    if(partial.valves){
        localStorage.setItem(
            "valves",
            JSON.stringify(next.valves)
        );
    }

        if(partial.interlocks){
        localStorage.setItem(
            "interlocks",
            JSON.stringify(next.interlocks)
        );
    }

        if(partial.flowOverrides){
        localStorage.setItem(
            "flowOverrides",
            JSON.stringify(next.flowOverrides)
        );
    }

    this.listeners.forEach(fn=>fn(this.state));

}


setInterlock(tag, value){

    this.set({

        interlocks:{

            ...this.state.interlocks,

            [tag]: value

        }

    });

}



getInterlock(tag){

    return this.state.interlocks?.[tag];

}

  subscribe(fn) {
    this.listeners.add(fn);

    return () => this.listeners.delete(fn);
  }
}







export const PlantStore = new PlantStoreClass();